import { useWbsSectionStore } from '@/features/projectStructure/store/sectionStore';
import { getSectionDescendants } from '@/features/projectStructure/utils/sectionTreeUtils';
import { useScheduleViewStore } from '@/features/scheduleViews/scheduleViewStore';
import { getScheduler } from '@/services/store/integrations/scheduler';
import { getResourcesWithEvents } from '@/services/store/schedule/actions/filter';

export const useDisplayedSchedulerSections = () => {
  const displayedSchedulerSectionIds = computed(() => {
    const scheduleViewStore = useScheduleViewStore();
    const scheduler = getScheduler();
    const sections = useWbsSectionStore();
    if (!scheduler) return new Set<string>();

    const resourcesWithEvents = getResourcesWithEvents(scheduler);

    const filterState = scheduleViewStore.currentFilter;
    const allowedSections = new Set(filterState.sections);

    const shouldShowSection = (sectionId: string) => {
      let isAllowed = true;

      if (allowedSections.size > 0) {
        isAllowed = allowedSections.has(sectionId);
      }
      if (filterState.contributorGroups.length || filterState.trades.length) {
        return isAllowed && resourcesWithEvents.has(sectionId);
      }
      return isAllowed;
    };

    const displayedSchedulerSectionIds = Array.from(sections.wbsSections.keys()).filter(
      (id) =>
        shouldShowSection(id) ||
        getSectionDescendants(id, sections.wbsSections, sections.wbsSectionsChildrenMap).some(
          (descendant) => shouldShowSection(descendant.id),
        ),
    );
    return new Set(displayedSchedulerSectionIds);
  });

  return {
    displayedSchedulerSectionIds,
  };
};
